export const BLOCKED_STATUS = 'blocked';
export const NO_ATTEPMTS_LEFT_STATUS = 'no-attempts';
export const ASK_FOR_ZIP_CODE_STATUS = 'ask-for-zip-code';
export const INCORRECT_ZIP_CODE_STATUS = 'incorrect-zip-code';
